<template lang="pug">
    .celebrity-bio(v-if="facts && (facts.description || (facts.bio && facts.bio.text))")
        ._title(v-if="!embedded") {{ locale("title") }}
        ._lead(v-if="facts.description") {{ lead }}
        ._text(v-if="facts.bio && facts.bio.text") {{ shownText }}
        ._more(v-if="isLong && !open" @click="open = true") {{ locale("more") }}
        ._source(v-if="facts.bio && facts.bio.url")
            | {{ locale("source") }}:&nbsp;
            a._source-link(:href="facts.bio.url" target="_blank" rel="noopener nofollow") {{ locale("wikipedia") }}
            | , {{ license }}
</template>

<script>
// Биография и подпись знаменитости. Данные лежат статическим файлом /celebrity-facts/<slug>.json,
// их собирает scripts/celebrity-facts/collect_facts.py (Викиданные и Википедия), в базе под них поля нет.
// Текст Википедии показываем со ссылкой на источник и лицензией CC BY-SA, как требует лицензия.
const SHORT_LIMIT = 420;

export default {
    name: "CelebrityBio",
    props: {
        embedded: { type: Boolean, default: false },
    },
    data: () => ({ facts: null, open: false }),
    computed: {
        slug: (state) => state.$store.getters["person/url"],
        lead() {
            const text = this.facts.description || "";
            return text.charAt(0).toUpperCase() + text.slice(1);
        },
        // В файле лицензия записана как «CC BY-SA 4.0, Wikipedia»: слово Wikipedia уже в ссылке
        license() {
            return String((this.facts.bio && this.facts.bio.license) || "").replace(/,\s*Wikipedia$/, "");
        },
        fullText() {
            return (this.facts && this.facts.bio && this.facts.bio.text) || "";
        },
        isLong() {
            return this.fullText.length > SHORT_LIMIT;
        },
        shownText() {
            if (this.open || !this.isLong) return this.fullText;
            const cut = this.fullText.slice(0, SHORT_LIMIT);
            return `${cut.slice(0, Math.max(cut.lastIndexOf(" "), 200))}…`;
        },
    },
    watch: {
        slug() {
            this.load();
        },
    },
    created() {
        this.load();
    },
    methods: {
        async load() {
            this.facts = null;
            this.open = false;
            const slug = this.slug;
            if (!slug || !/^[a-z0-9_]+$/i.test(slug)) return;
            try {
                const response = await fetch(`/celebrity-facts/${slug}.json`);
                if (!response.ok) return;
                // Статический каталог: если сервер на неизвестный файл отдаёт index.html, это не JSON
                const type = response.headers.get("content-type") || "";
                if (type.indexOf("json") < 0) return;
                const data = await response.json();
                if (slug === this.slug) this.facts = data;
            } catch (e) {
                // Нет файла или сети: блок просто не показываем
            }
        },
    },
};
</script>

<style lang="scss">
.celebrity-bio {
    padding: 20px;
    margin-top: 20px;
    background: #2c2c2c;
    border-radius: 12px;
    color: #d6d6d6;
    font-size: 14px;
    line-height: 1.55;

    &__title {
        margin-bottom: 14px;
        font-size: 18px;
        text-transform: uppercase;
        color: #fff;
    }

    &__lead {
        margin-bottom: 10px;
        color: #fff;
        font-size: 15px;
    }

    &__text {
        white-space: pre-line;
    }

    &__more {
        margin-top: 8px;
        color: #c4a35a;
        cursor: pointer;
    }

    &__source {
        margin-top: 12px;
        font-size: 12px;
        color: #8d8d8d;
    }

    &__source-link {
        color: #8d8d8d;
        text-decoration: underline;
    }

    @media (max-width: 991px) {
        margin-top: 5px;
        padding: 15px;
    }
}
</style>
